import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { memo } from 'react'

import IconExport from '@/components/base/IconExport'
import { getAddressUrl } from '@/utils/helpers'

import type { TopCoinsDataItem } from './types'

const View = ({ data }: { data: TopCoinsDataItem }) => {
  return (
    <Stack direction="row" alignItems="center" gap="8px">
      <img
        src={data.logo}
        alt={data.tokenName}
        className="w-[24px] h-[24px] max-w-[24px] object-cover"
      />
      <Stack gap="4px">
        <Stack direction="row" gap="4px" alignItems="center" className="whitespace-nowrap">
          <Typography className="text-base text-white font-semibold lg:max-w-[130px] text-ellipsis overflow-hidden">
            {data.tokenName}
          </Typography>
          <Typography className="text-[#C2CBD9] text-xs"> - {data.symbol}</Typography>
          <a
            href={getAddressUrl(data.tokenMint)}
            target="_blank"
            rel="noreferrer"
            className="shrink-0"
            onClick={(evt) => evt.stopPropagation()}
          >
            <IconExport />
          </a>
        </Stack>
        <Typography className="text-xs text-[#C2CBD9]">{data.price}</Typography>
      </Stack>
    </Stack>
  )
}

export default memo(View)
